import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Signal } from '@models/dashboard/signal';
import { ChartAxisSettings } from '@models/pages/user-defined-page/chart-axis-settings';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogService } from '@services/confirmation-dialog.service';

@Component({
    selector: 'scitis-line-widget-axis-display',
    templateUrl: './line-widget-axis-display.component.html',
    styleUrls: ['./line-widget-axis-display.component.scss'],
    standalone: false
})
export class LineWidgetAxisDisplayComponent {
  @Input()
  isSelectedAxis: boolean | undefined = false;

  @Input()
  axisSettings: ChartAxisSettings = new ChartAxisSettings();

  @Input()
  usableSignals: Signal[] = [];

  @Input()
  usedSignalIds: number[] = [];

  @Output()
  axisStartEditEvent: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  axisDeleteEvent: EventEmitter<ChartAxisSettings> = new EventEmitter<ChartAxisSettings>();

  @Output()
  axisSettingsChanged: EventEmitter<ChartAxisSettings> = new EventEmitter<ChartAxisSettings>();

  hasDeletedSignals: boolean = false;

  constructor(private translate: TranslateService,
              private confirmationDialogService: ConfirmationDialogService) {
  }

  public get isAxisMisconfigured(): boolean {
    return !this.axisSettings ||
        !this.axisSettings.axisYLabel || this.axisSettings.axisYLabel.isNullOrWhitespace() ||
        !this.axisSettings.signals || this.axisSettings.signals.length === 0;
  }

  onAxisSettingsStartEdit() {
    this.isSelectedAxis = true;
    this.axisStartEditEvent.emit(this.axisSettings.id);
  }

  onRemoveAxis(axisSettings: ChartAxisSettings) {

    const removeMessageTitle = this.translate.instant('Delete Axis');
    const removeMessageBody = this.translate.instant('Do you really want to delete the axis %s ?').replace('%s', axisSettings.axisYLabel.toBold());
    const removeMessageOK = this.translate.instant('Delete axis');

    this.confirmationDialogService.handleConfirmationDialog(removeMessageTitle, removeMessageBody, '',
        removeMessageOK).subscribe(userConfirmed => {
      if (userConfirmed) {
        this.axisDeleteEvent.emit(axisSettings);
      }
    });
  }

  onAxisSettingsChanged($event: ChartAxisSettings) {
    this.axisSettingsChanged.emit($event);
  }

  onHasDeletedSignalsChanged($event: boolean) {
    this.hasDeletedSignals = $event;
  }
}
